/**
 * Provides basic JS functionality for tabs.
 */
export class Tabs extends DrupalBehavior {
  onContent(context) {
    $('.tabs', context).each(function (index, tabs) {
      let slideIndex = 0;
      $('.tab-nav button', tabs).each(function (index, button) {
        $(button).attr('data-slide-index', slideIndex);
        slideIndex++;
      });

      const $slider = $('.tab-content', tabs);
      /* istanbul ignore next - No need to test Slick */
      $slider.on('init', function () {
        slideIndex = $('.tab-content .slick-active', tabs).attr(
          'data-slick-index'
        );
        $('.tab-nav [data-slide-index="' + slideIndex + '"]', tabs).addClass(
          'active'
        );
        $('.tab-nav button', tabs).on('click', function (e) {
          e.preventDefault();
          slideIndex = $(this).attr('data-slide-index');
          $('.tab-content', tabs).slick('slickGoTo', slideIndex);
        });
      });

      const slickOptions = {
        dots: false,
        slidesToShow: 1,
        speed: 500,
        mobileFirst: true,
        draggable: true,
        fade: false,
        arrows: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              dots: false,
              draggable: false,
              fade: true,
            },
          },
        ],
      };

      if ($slider.hasClass('autorotate')) {
        slickOptions.autoplay = true;
      }

      $slider.slick(slickOptions);

      /* istanbul ignore next - No need to test Slick */
      $slider.on('beforeChange', function (slick, currentSlide) {
        $(
          '.tab-nav [data-slide-index="' + currentSlide.currentSlide + '"]',
          tabs
        ).removeClass('active');
      });
      /* istanbul ignore next - No need to test Slick */
      $slider.on('afterChange', function (slick, currentSlide) {
        $(
          '.tab-nav [data-slide-index="' + currentSlide.currentSlide + '"]',
          tabs
        ).addClass('active');
      });
    });
  }
}

DrupalBehavior.register('rush_theme.components', 'tabs', Tabs);
